
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.47 14.47a.75.75 0 101.06 1.06L.47 14.47zM15.53 1.53A.75.75 0 0014.47.47l1.06 1.06zM1.53.47A.75.75 0 00.47 1.53L1.53.47zm12.94 15.06a.75.75 0 101.06-1.06l-1.06 1.06zm-12.94 0l14-14L14.47.47l-14 14 1.06 1.06zm-1.06-14l14 14 1.06-1.06-14-14L.47 1.53z","fill":"currentColor"}})])
          )
        }
      }
    